// extracted by mini-css-extract-plugin
export default {"promo-text":"PromoText_promo-text__KvANb"};